// ---- his round ----
// The spelling loop is the engine's (core/round.ts). This is the half that is
// his: which words there are, whether one can be dealt yet, what happens when
// a word is finished — the animal arrives and he turns and welcomes it by name
// — and what a tap on him or on one of them does.
import {setRound} from '../../core/round';
import {interrupt,sayWord,sndPop} from '../../core/audio';
import {tpl} from './animals';
import {BRAINS} from './brains';
import {ANIMALS,INTRO} from './data';
import {animals,arrive,jiddo} from './field';
import {greet,poke,react} from './jiddo';
import type {Animal} from './types';

setRound({
  roster:ANIMALS,
  ready:w=>!!tpl[w],
  intro:INTRO,
  greet,
  arrive:(w,t)=>{const spec=ANIMALS.find(x=>x.w===w)!;return arrive(spec,BRAINS[spec.brain],t);},
  // His welcome is the only voice an arrival gets: the name was already said
  // when the round opened. He turns to it and talks with his hands.
  answer:(a,t)=>react(a as Animal,t),
  count:()=>animals.length,
  elder:jiddo,
  poke,
  pickables:()=>animals,
  // a tap on an animal gets its name, and a little hop out of it
  tapped:(o,t)=>{const a=o.userData.ele as Animal;a.hopT=t;interrupt();sayWord(a.w);sndPop();},
});
